// @generated by protoc-gen-connect-query v1.4.2
// @generated from file fingertip/creator/asset/v1/asset.proto (package fingertip.creator.asset.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { MethodKind } from "@bufbuild/protobuf";
import { CreateAssetRequest, CreateAssetResponse, CreatePublicAssetRequest, CreatePublicAssetResponse, DeleteAssetRequest, DeleteAssetResponse, DeletePublicAssetRequest, DeletePublicAssetResponse, GetAssetRequest, GetAssetResponse, GetSiteAssetsRequest, GetSiteAssetsResponse } from "./asset_pb.js";

/**
 * @generated from rpc fingertip.creator.asset.v1.AssetService.CreateAsset
 */
export const createAsset = {
  localName: "createAsset",
  name: "CreateAsset",
  kind: MethodKind.Unary,
  I: CreateAssetRequest,
  O: CreateAssetResponse,
  service: {
    typeName: "fingertip.creator.asset.v1.AssetService"
  }
};

/**
 * @generated from rpc fingertip.creator.asset.v1.AssetService.GetAsset
 */
export const getAsset = {
  localName: "getAsset",
  name: "GetAsset",
  kind: MethodKind.Unary,
  I: GetAssetRequest,
  O: GetAssetResponse,
  service: {
    typeName: "fingertip.creator.asset.v1.AssetService"
  }
};

/**
 * @generated from rpc fingertip.creator.asset.v1.AssetService.CreatePublicAsset
 */
export const createPublicAsset = {
  localName: "createPublicAsset",
  name: "CreatePublicAsset",
  kind: MethodKind.Unary,
  I: CreatePublicAssetRequest,
  O: CreatePublicAssetResponse,
  service: {
    typeName: "fingertip.creator.asset.v1.AssetService"
  }
};

/**
 * @generated from rpc fingertip.creator.asset.v1.AssetService.DeleteAsset
 */
export const deleteAsset = {
  localName: "deleteAsset",
  name: "DeleteAsset",
  kind: MethodKind.Unary,
  I: DeleteAssetRequest,
  O: DeleteAssetResponse,
  service: {
    typeName: "fingertip.creator.asset.v1.AssetService"
  }
};

/**
 * @generated from rpc fingertip.creator.asset.v1.AssetService.DeletePublicAsset
 */
export const deletePublicAsset = {
  localName: "deletePublicAsset",
  name: "DeletePublicAsset",
  kind: MethodKind.Unary,
  I: DeletePublicAssetRequest,
  O: DeletePublicAssetResponse,
  service: {
    typeName: "fingertip.creator.asset.v1.AssetService"
  }
};

/**
 * @generated from rpc fingertip.creator.asset.v1.AssetService.GetSiteAssets
 */
export const getSiteAssets = {
  localName: "getSiteAssets",
  name: "GetSiteAssets",
  kind: MethodKind.Unary,
  I: GetSiteAssetsRequest,
  O: GetSiteAssetsResponse,
  service: {
    typeName: "fingertip.creator.asset.v1.AssetService"
  }
};
